import React from 'react';
import toast, { Toaster, ToastBar } from 'react-hot-toast';

/**
 * Global toast notification container with dismiss button
 */
const ToastContainer: React.FC = () => {
  return (
    <div data-test-id="toast-container">
      <Toaster position="bottom-right" reverseOrder={false} gutter={8}>
        {(t) => (
          <ToastBar toast={t}>
            {({ icon, message }) => (
              <>
                {icon}
                {message}
                {t.type !== 'loading' && (
                  <button
                    onClick={() => toast.dismiss(t.id)}
                    style={{
                      marginLeft: '8px',
                      background: 'transparent',
                      border: 'none',
                      color: 'inherit',
                      cursor: 'pointer',
                      fontSize: '20px',
                      lineHeight: '1',
                      padding: '4px',
                      opacity: 0.7
                    }}
                    onMouseEnter={(e) => (e.currentTarget.style.opacity = '1')}
                    onMouseLeave={(e) => (e.currentTarget.style.opacity = '0.7')}
                    aria-label="Dismiss notification"
                  >
                    ×
                  </button>
                )}
              </>
            )}
          </ToastBar>
        )}
      </Toaster>
    </div>
  );
};

export default ToastContainer;
